import React from 'react';

const AboutBanner = () => {
    return (
        <div>
            <section id="about">
       <div class="container">
           <div class="row">
               <div class="about-heading text-center">
                   <h2>About us</h2>
                   <p><a href="/home">home</a> <i class="fa fa-chevron-right"></i><i class="fa fa-chevron-right"></i> <span>about</span></p>
               </div>
           </div>
       </div>
   </section>
        </div>
    );
};

export default AboutBanner;